import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SimpleEntityListPerspective } from '@homeleite/common-components';
import { ProducerSummary } from '@homeleite/domain';
import { ProducersApiRepository } from '../../../../../../libs/domain/src/lib/producers/producers-api.repository';
import { MatDialog } from '@angular/material/dialog';
import { FirstAccessDialogComponent } from './first-access-dialog/first-access-dialog.component';


@Component({
    selector: 'homeleite-producers',
    templateUrl: './producers.component.html',
    styleUrls: ['./producers.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class ProducersComponent {
  search = '';

  perspective = new SimpleEntityListPerspective();

  constructor(
      private dialog: MatDialog,
      public repository: ProducersApiRepository,
      private router: Router
  ) {}

  openEntity(entity: ProducerSummary) {
    this.router.navigate(['/producers', entity.id]);
  }

  openFirstAccess(): void{
      this.dialog.open(FirstAccessDialogComponent, {
          width: '100vw',
          height: '100vh',
          maxWidth: '100vw',
          panelClass: 'full-screen-dialog'
      })
  }
}
